import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from '@/locales/en/common.json';
import es from '@/locales/es/common.json';
import pt from '@/locales/pt/common.json';

// Supported languages, aligned with profiles.preferred_language enum
// in the schema. `en` is the reference — es/pt keep the same key tree.
export const LANGUAGES = [
  { code: 'en', label: 'English', flag: '🇺🇸' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'pt', label: 'Português', flag: '🇧🇷' },
] as const;
export type LanguageCode = (typeof LANGUAGES)[number]['code'];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: en },
      es: { common: es },
      pt: { common: pt },
    },
    defaultNS: 'common',
    fallbackLng: 'en',
    supportedLngs: LANGUAGES.map((l) => l.code),
    interpolation: { escapeValue: false },
    detection: {
      // Respect profile.preferred_language when set via setLanguage();
      // otherwise fall through to browser + localStorage cache.
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'dubs_lang',
    },
  });

export default i18n;
